import { useState, useEffect } from 'react'

let currentZoom = 1
const listeners = []

export const getZoom = () => currentZoom

export const setZoom = (newZoom) => {
  currentZoom = newZoom
  listeners.forEach(fn => fn(currentZoom))
}

export const subscribe = (fn) => {
  listeners.push(fn)
  return () => {
    const idx = listeners.indexOf(fn)
    if (idx >= 0) listeners.splice(idx, 1)
  }
}

export const useZoom = () => {
  const [zoom, setZoomState] = useState(currentZoom)
  useEffect(() => subscribe(setZoomState), [])
  return zoom
}
